// frontend/src/admin/ExamHallTicketPage.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import BASE_URL from "../config";
import { footerConfigs } from "../components/footerConfigs";
import "bootstrap/dist/css/bootstrap.min.css";
const ExamHallTicketPage = () => {
    // SCHOOL CONFIG
    const schoolConfig = footerConfigs.bheema;
    // STATES
    const [exams, setExams] = useState([]);
    const [selectedExam, setSelectedExam] = useState(null);
    const [students, setStudents] = useState([]);
    const [loadingExams, setLoadingExams] = useState(false);
    const [loadingStudents, setLoadingStudents] = useState(false);
    const [printing, setPrinting] = useState(false);
    const [printingStudentId, setPrintingStudentId] = useState(null);
    // LOAD EXAMS
    useEffect(() => {
        loadExams();
    }, []);
    const loadExams = async () => {
        try {
            setLoadingExams(true);
            const res =
                await axios.get(
                    `${BASE_URL}/api/exams`
                );
            const rows =
                Array.isArray(res.data)
                    ? res.data
                    : [];
            const formatted =
                rows.map((r) => ({
                    ...r,
                    DisplayName:
                        `${r.ExamName} - [` +
                        `${r.ClassName}` +
                        `${r.SectionName
                            ? " " + r.SectionName
                            : ""}` +
                        `] - (${r.AcademicYearName})`

                }));
            setExams(formatted);
        } catch (error) {
            console.error(
                "Error loading exams:",
                error
            );
            alert(
                error.response?.data?.message ||
                "Unable to load examinations."
            );
        } finally {
            setLoadingExams(false);
        }
    };
    // EXAM CHANGE
    const handleExamChange = async (index) => {
        if (
            index === "" ||
            index === null ||
            index === undefined
        ) {
            setSelectedExam(null);
            setStudents([]);
            return;
        }
        const exam =
            exams[Number(index)];
        if (!exam) {
            setSelectedExam(null);
            setStudents([]);
            return;
        }
        setSelectedExam(exam);
        await loadStudents(exam);
    };
    // LOAD STUDENTS
    const loadStudents = async (exam) => {
        try {
            setLoadingStudents(true);
            setStudents([]);
            const params = {
                courseId:
                    Number(exam.CourseID),
                classId:
                    Number(exam.ClassID),
                academicYearId:
                    Number(exam.AcademicYearID),
                sectionId:
                    exam.SectionID == null
                        ? null
                        : Number(exam.SectionID)

            };
            console.log(
                "Loading hall ticket students:",
                params
            );
            const res =
                await axios.get(
                    `${BASE_URL}/api/exam-hall-ticket/students`,
                    {
                        params
                    }
                );
            setStudents(
                Array.isArray(res.data)
                    ? res.data
                    : []
            );
        } catch (error) {
            console.error(
                "Error loading students:",
                error
            );
            alert(
                error.response?.data?.message ||
                "Unable to load students."
            );
        } finally {
            setLoadingStudents(false);

        }
    };
    // ============================================================
    // IMAGE → BASE64
    // ============================================================

    const imageToBase64 = async (imageUrl) => {

        try {

            const response =
                await fetch(imageUrl);


            if (!response.ok) {

                throw new Error(
                    "Unable to load school logo."
                );

            }


            const blob =
                await response.blob();


            return new Promise(
                (resolve, reject) => {

                    const reader =
                        new FileReader();


                    reader.onloadend =
                        () => resolve(
                            reader.result
                        );


                    reader.onerror =
                        reject;


                    reader.readAsDataURL(
                        blob
                    );

                }
            );

        } catch (error) {

            console.error(
                "Logo conversion error:",
                error
            );

            return null;

        }

    };


    // ============================================================
    // GENERATE PDF
    //
    // studentId = null → ALL STUDENTS
    // studentId = ID   → INDIVIDUAL STUDENT
    // ============================================================

    const generateHallTicket = async (
        studentId = null
    ) => {

        if (!selectedExam) {

            alert(
                "Please select an examination."
            );

            return;

        }


        if (
            !selectedExam.ExamID ||
            !selectedExam.CourseID ||
            !selectedExam.ClassID ||
            !selectedExam.AcademicYearID
        ) {

            alert(
                "Selected examination has incomplete information."
            );

            return;

        }


        try {

            if (studentId) {

                setPrintingStudentId(
                    studentId
                );

            } else {

                setPrinting(true);

            }


            // ====================================================
            // SCHOOL LOGO
            // ====================================================

            const logoBase64 =
                await imageToBase64(
                    schoolConfig.logo
                );


            // ====================================================
            // FOOTER CONFIG
            // ====================================================

            const footerConfig = {

                trust:
                    schoolConfig.trust || "",

                brandName:
                    schoolConfig.brandName || "",

                smsSchoolName:
                    schoolConfig.smsSchoolName || "",

                address:
                    schoolConfig.address || "",

                contact:
                    schoolConfig.contact || "",

                domain:
                    schoolConfig.domain || "",

                logo:
                    logoBase64

            };


            // ====================================================
            // PAYLOAD
            // ====================================================

            const payload = {

                examId:
                    Number(
                        selectedExam.ExamID
                    ),

                courseId:
                    Number(
                        selectedExam.CourseID
                    ),

                classId:
                    Number(
                        selectedExam.ClassID
                    ),

                sectionId:
                    selectedExam.SectionID == null
                        ? null
                        : Number(
                            selectedExam.SectionID
                        ),

                academicYearId:
                    Number(
                        selectedExam.AcademicYearID
                    ),

                // NULL = ALL STUDENTS
                // ID   = ONE STUDENT

                studentId:
                    studentId
                        ? Number(studentId)
                        : null,

                footerConfig

            };


            console.log(
                "Hall ticket PDF payload:",
                payload
            );


            // ====================================================
            // REQUEST PDF
            // ====================================================

            const response =
                await axios.post(
                    `${BASE_URL}/api/exam-hall-ticket/pdf`,
                    payload,
                    {
                        responseType:
                            "blob"
                    }
                );


            // ====================================================
            // CREATE PDF
            // ====================================================

            const blob =
                new Blob(
                    [response.data],
                    {
                        type:
                            "application/pdf"
                    }
                );


            const pdfUrl =
                window.URL.createObjectURL(
                    blob
                );


            // ====================================================
            // OPEN PDF
            // ====================================================

            const newWindow =
                window.open(
                    pdfUrl,
                    "_blank"
                );


            if (!newWindow) {

                alert(
                    "Please allow pop-ups for this website."
                );

            }


        } catch (error) {

            console.error(
                "Hall ticket generation error:",
                error
            );


            if (
                error.response?.data instanceof Blob
            ) {

                try {

                    const text =
                        await error.response.data.text();


                    const data =
                        JSON.parse(text);


                    alert(
                        data.message ||
                        "Unable to generate hall ticket."
                    );


                } catch {

                    alert(
                        "Unable to generate hall ticket."
                    );

                }

            } else {

                alert(
                    error.response?.data?.message ||
                    error.message ||
                    "Unable to generate hall ticket."
                );

            }


        } finally {

            setPrinting(false);

            setPrintingStudentId(null);

        }

    };


    // ============================================================
    // RENDER
    // ============================================================

    return (

        <div className="container-fluid py-4">

            <div className="card shadow-sm">

                {/* =================================================
                    HEADER
                ================================================= */}

                <div className="card-header bg-primary text-white">

                    <h4 className="mb-0">

                        Exam Hall Ticket / Admit Card

                    </h4>

                </div>


                <div className="card-body">


                    {/* =================================================
                        EXAM SELECT
                    ================================================= */}

                    <div className="row">

                        <div className="col-md-9">

                            <label
                                className="form-label fw-bold"
                            >
                                Select Examination
                            </label>


                            <select
                                className="form-select"
                                value={
                                    selectedExam
                                        ? exams.indexOf(
                                            selectedExam
                                        )
                                        : ""
                                }
                                onChange={(e) =>
                                    handleExamChange(
                                        e.target.value
                                    )
                                }
                                disabled={
                                    loadingExams
                                }
                            >

                                <option value="">

                                    {loadingExams
                                        ? "Loading examinations..."
                                        : "Select Examination"}

                                </option>


                                {exams.map(
                                    (exam, index) => (

                                        <option
                                            key={
                                                `${exam.ExamID}-${exam.CourseID}-${exam.ClassID}-${exam.SectionID ?? "null"}-${exam.AcademicYearID}-${index}`
                                            }
                                            value={index}
                                        >
                                            {
                                                exam.DisplayName
                                            }
                                        </option>

                                    )
                                )}

                            </select>

                        </div>

                    </div>


                    {/* =================================================
                        SELECTED EXAM
                    ================================================= */}

                    {selectedExam && (

                        <>

                            <div className="card mt-4 border">

                                <div className="card-header">

                                    <strong>
                                        Examination Details
                                    </strong>

                                </div>


                                <div className="card-body">

                                    <div className="row g-3">

                                        <div className="col-md-4">

                                            <small className="text-muted">
                                                Examination
                                            </small>

                                            <div className="fw-bold">
                                                {
                                                    selectedExam.ExamName
                                                }
                                            </div>

                                        </div>


                                        <div className="col-md-4">

                                            <small className="text-muted">
                                                Course
                                            </small>

                                            <div className="fw-bold">
                                                {
                                                    selectedExam.CourseName
                                                }
                                            </div>

                                        </div>


                                        <div className="col-md-4">

                                            <small className="text-muted">
                                                Class
                                            </small>

                                            <div className="fw-bold">
                                                {
                                                    selectedExam.ClassName
                                                }
                                            </div>

                                        </div>


                                        <div className="col-md-4">

                                            <small className="text-muted">
                                                Section
                                            </small>

                                            <div className="fw-bold">
                                                {
                                                    selectedExam.SectionName ||
                                                    "No Section"
                                                }
                                            </div>

                                        </div>


                                        <div className="col-md-4">

                                            <small className="text-muted">
                                                Academic Year
                                            </small>

                                            <div className="fw-bold">
                                                {
                                                    selectedExam.AcademicYearName
                                                }
                                            </div>

                                        </div>


                                        <div className="col-md-4">

                                            <small className="text-muted">
                                                Students
                                            </small>

                                            <div className="fw-bold">
                                                {
                                                    loadingStudents
                                                        ? "Loading..."
                                                        : students.length
                                                }
                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>


                            {/* =================================================
                                STUDENT LIST
                            ================================================= */}

                            <div className="card mt-4 border">

                                <div className="card-header d-flex justify-content-between align-items-center">

                                    <strong>
                                        Students
                                    </strong>


                                    <button
                                        type="button"
                                        className="btn btn-success"
                                        onClick={() =>
                                            generateHallTicket(
                                                null
                                            )
                                        }
                                        disabled={
                                            loadingStudents ||
                                            students.length === 0 ||
                                            printing ||
                                            printingStudentId !== null
                                        }
                                    >

                                        {printing
                                            ? "Generating..."
                                            : "🖨 Print All Students"}

                                    </button>

                                </div>


                                <div className="card-body p-0">

                                    {loadingStudents ? (

                                        <div className="text-center p-4">

                                            <div
                                                className="spinner-border text-primary"
                                                role="status"
                                            />

                                            <div className="mt-2">

                                                Loading students...

                                            </div>

                                        </div>

                                    ) : students.length === 0 ? (

                                        <div className="alert alert-warning m-3">

                                            No students found for the selected examination.

                                        </div>

                                    ) : (

                                        <div className="table-responsive">

                                            <table className="table table-bordered table-hover mb-0">

                                                <thead className="table-light">

                                                    <tr>

                                                        <th
                                                            style={{
                                                                width: "70px"
                                                            }}
                                                        >
                                                            #
                                                        </th>

                                                        <th>
                                                            Roll Number
                                                        </th>

                                                        <th>
                                                            Student Name
                                                        </th>

                                                        <th>
                                                            Class
                                                        </th>

                                                        <th>
                                                            Section
                                                        </th>

                                                        <th
                                                            style={{
                                                                width: "150px"
                                                            }}
                                                        >
                                                            Action
                                                        </th>

                                                    </tr>

                                                </thead>


                                                <tbody>

                                                    {students.map(
                                                        (student, index) => (

                                                            <tr
                                                                key={
                                                                    student.StudentID
                                                                }
                                                            >

                                                                <td>
                                                                    {
                                                                        index + 1
                                                                    }
                                                                </td>


                                                                <td>

                                                                    {
                                                                        student.RollNumber ||
                                                                        "-"
                                                                    }

                                                                </td>


                                                                <td>

                                                                    <strong>
                                                                        {
                                                                            student.StudentName
                                                                        }
                                                                    </strong>

                                                                </td>


                                                                <td>

                                                                    {
                                                                        student.ClassName
                                                                    }

                                                                </td>


                                                                <td>

                                                                    {
                                                                        student.SectionName ||
                                                                        "-"
                                                                    }

                                                                </td>


                                                                <td>

                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-primary"
                                                                        onClick={() =>
                                                                            generateHallTicket(
                                                                                student.StudentID
                                                                            )
                                                                        }
                                                                        disabled={
                                                                            printing ||
                                                                            printingStudentId !== null
                                                                        }
                                                                    >

                                                                        {printingStudentId ===
                                                                        student.StudentID
                                                                            ? "Generating..."
                                                                            : "🖨 Print"}

                                                                    </button>

                                                                </td>

                                                            </tr>

                                                        )
                                                    )}

                                                </tbody>

                                            </table>

                                        </div>

                                    )}

                                </div>

                            </div>

                        </>

                    )}

                </div>

            </div>

        </div>

    );

};


export default ExamHallTicketPage;